// extracted by mini-css-extract-plugin
export var container = "_qj-0";
export var dotAnimation = "_qj-2";
export var dotsLoading = "_qj-1";